import React from "react";
import ReactDOM from "react-dom";
import { Modal } from "react-bootstrap";
import "./Modal.portal.scss";

const ModalPortal = ({
  mostrar = false,
  mostrarFooter = true,
  handleCerrar,
  children,
  footer = null,
  header = null,
  tamano = "",
}) => {
  if (!mostrar) {
    return null;
  }
  return ReactDOM.createPortal(
    <Modal show={mostrar} onHide={handleCerrar} size={tamano}>
      <Modal.Header closeButton>{header}</Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {mostrarFooter === true ? <Modal.Footer>{footer}</Modal.Footer> : null}
    </Modal>,
    document.getElementById("modal")
  );
};

export default ModalPortal;
